/**
 * Sync Layer Types
 * Types for bidirectional synchronization between Dexie and Supabase
 */

export type SyncStatus = 'idle' | 'syncing' | 'synced' | 'error' | 'offline'

export interface SyncState {
  status: SyncStatus
  lastSyncAt?: Date
  error?: string
  pendingChanges: number
}

export interface SyncConflict {
  id: string
  table: 'tasks' | 'settings' | 'projects' | 'sections' | 'tags'
  localData: any
  remoteData: any
  timestamp: Date
}

export interface SyncResult {
  success: boolean
  synced: {
    created: number
    updated: number
    deleted: number
  }
  conflicts: SyncConflict[]
  errors: string[]
}

export type ConflictResolutionStrategy = 'local-wins' | 'remote-wins' | 'last-write-wins' | 'manual'

export function createEmptySyncResult(): SyncResult {
  return { success: false, synced: { created: 0, updated: 0, deleted: 0 }, conflicts: [], errors: [] }
}

export interface SyncOptions {
  conflictResolution?: ConflictResolutionStrategy
  force?: boolean
  tables?: ('tasks' | 'settings' | 'projects' | 'sections' | 'tags')[]
}
